export default function NoneLayout({ children }: any) {
  return <>{children}</>
}
